import { PoMenuItem } from "@po-ui/ng-components";

export function pathExistOnMenu(menuItems: PoMenuItem[], locationPath: string): PoMenuItem | null {
    if(menuItems === null)
        return null;

    for(const item of menuItems) {
        if(item.link === locationPath)
            return item;

        if(item.subItems) {
            const PoMenuItem = pathExistOnMenu(item.subItems, locationPath);
            if(PoMenuItem)
                return PoMenuItem;
        }
    }

    return null;
}